/**
 * Fontawesome Javascript SVG api
 *
 * https://fontawesome.com/how-to-use/with-the-api/setup/getting-started
 */

import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Import specific icons required. This format applies tree-shaking
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt';
import { faRocket } from '@fortawesome/free-solid-svg-icons/faRocket';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSpaceShuttle } from '@fortawesome/free-solid-svg-icons/faSpaceShuttle';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserAstronaut } from '@fortawesome/free-solid-svg-icons/faUserAstronaut';
import { faSearchMinus } from '@fortawesome/free-solid-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import { faGlobeAsia } from '@fortawesome/free-solid-svg-icons/faGlobeAsia';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';

// Add specific icons required
library.add(
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
  faWhatsapp,
  faBars,
  faEnvelope,
  faMapMarkerAlt,
  faPhoneAlt,
  faRocket,
  faSearch,
  faSpaceShuttle,
  faTimes,
  faUser,
  faUserAstronaut,
  faSearchMinus,
  faSearchPlus,
  faGlobeAsia,
  faChevronLeft
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
export default () => dom.watch();
